import { defineComponent as _defineComponent } from 'vue';
import { defineComponent } from 'vue';
import { TheModal } from '@/app/overlay-orchestrator';
import UnauthorizedLayout from '@/app/ui/UnauthorizedLayout.vue';
import CustomTemplateWithLeftBlock from '@/shared/ui/templates/CustomTemplateWithLeftBlock.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutWithLeftBlockImage',
  setup: function setup(__props) {
    defineComponent({
      name: 'LayoutWithLeftBlockImage'
    });
    return {
      __sfc: true,
      TheModal: TheModal,
      UnauthorizedLayout: UnauthorizedLayout,
      CustomTemplateWithLeftBlock: CustomTemplateWithLeftBlock
    };
  }
});